// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__P96M4","footer":"ModalError_footer__368oD"};